import React from 'react';
import { PARAMS } from "../../../../config";
const backgroundRed = { background: 'red' };

const Row = ({ row }) => {
    let td = getValues(row);

    return (
        <tr>
            <td>{row.n}</td>
            <td>{row.a}</td>
            <td>{row.s}</td>
            {td}
        </tr>
    );
};

function getValues(row) {
    return PARAMS.map(paramObj => {
        const param = paramObj[0];
        const paramType = paramObj[2];
        const value = row[param];

        const styles = paramType === 'roi' && value < 0 ? backgroundRed : {};

        return(<td style={styles} key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AkFull/components/Table/components/Row/index.js